import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { fetchAlbums } from "../[slug]/api";
export const useFetchAlbums = digitalProfile => {
  const $ = _c(7);
  const t0 = digitalProfile?.id;
  let t1;
  if ($[0] !== t0) {
    t1 = ["dp-albums", t0];
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== digitalProfile) {
    t2 = () => fetchAlbums({
      id: digitalProfile.id
    });
    $[2] = digitalProfile;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = {
      queryKey: t1,
      queryFn: t2
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return useQuery(t3);
};